import {FormProvider, useForm} from "react-hook-form";
import {
  createLiveEventBasicFormStepFormValidationSchema,
  CreateLiveEventBasicFormStepFormValues,
} from "./schema-validation";
import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useNavigate} from "react-router-dom";
import {LiveEventOfferingForm} from "../../../../../components/offering-form/live-events";
import {useCreateLiveEventContext} from "../../context/create-live-event";
import {useOAuthCalendarResume} from "../../../../../utils/google-calendar-resume";

export function CreateLiveEventBasicFormStep() {
  const navigate = useNavigate();
  const {
    dispatch,
    state: {formData},
  } = useCreateLiveEventContext();
  const snapshot = useOAuthCalendarResume<CreateLiveEventBasicFormStepFormValues>();

  const formMethods = useForm<CreateLiveEventBasicFormStepFormValues>({
    resolver: yupResolver(createLiveEventBasicFormStepFormValidationSchema),
    mode: "onSubmit",
    defaultValues: snapshot ?? formData,
  });
  // console.log({formData});
  // console.log({watchClassSeries: formMethods.watch("classSeries")});

  function onSubmit(values: CreateLiveEventBasicFormStepFormValues) {
    // console.log({values});
    dispatch({
      type: "go-to-checkout-form-step",
      payload: values,
    });
  }

  // console.log({watch: formMethods.watch(), errors: formMethods.formState.errors});

  const isFormError = Object.keys(formMethods.formState.errors).length > 0;
  const isGeneralInformationError =
    formMethods.formState.errors.name ||
    formMethods.formState.errors.description ||
    formMethods.formState.errors.coverImage;
  const isPricingError =
    formMethods.formState.errors.callPriceType ||
    formMethods.formState.errors.currencies ||
    formMethods.formState.errors.callPrice ||
    formMethods.formState.errors.callPriceCurrency;
  const isSettingsError =
    formMethods.formState.errors.hideFromProfile ||
    formMethods.formState.errors.isUrlRedirect ||
    formMethods.formState.errors.requestCustomerPhoneNumber ||
    formMethods.formState.errors.telegramGroupId ||
    formMethods.formState.errors.limitUnitsPerTransaction ||
    formMethods.formState.errors.purchaseLimit ||
    formMethods.formState.errors.url_redirect;

  const isAttendeesError =
    formMethods.formState.errors.attendees || formMethods.formState.errors.attendeesType;
  const isLocationError =
    formMethods.formState.errors.callLocation || formMethods.formState.errors.customUrl;
  const isEventTypeError =
    formMethods.formState.errors.classSeries ||
    formMethods.formState.errors.customDuration ||
    formMethods.formState.errors.duration ||
    formMethods.formState.errors.startDate ||
    formMethods.formState.errors.startTime ||
    formMethods.formState.errors.topicType;
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
        <Space direction="vertical" size={16} style={{display: "flex"}}>
          <LiveEventOfferingForm
            isAttendeesError={!!isAttendeesError}
            isEventTypeError={!!isEventTypeError}
            isGeneralInformationError={!!isGeneralInformationError}
            isPricingError={!!isPricingError}
            isSettingsError={!!isSettingsError}
            isLocationError={!!isLocationError}
            formType="create"
          />

          {isFormError && (
            <Alert
              message="Please fill in the required fields above, outlined in red"
              type="warning"
            />
          )}

          <Row gutter={[0, 16]}>
            <Col span={24} sm={12}>
              <StyledServiceButtonWrapper>
                <Button
                  className="secondary-btn"
                  onClick={() => {
                    dispatch({
                      type: "reset-state",
                    });
                    navigate("/live-classes");
                  }}
                  block
                  size="small"
                  type="default"
                >
                  Back
                </Button>
                <Button
                  block
                  type="primary"
                  htmlType={"submit"}
                  size="small"
                  disabled={
                    Object.keys(formMethods.formState.errors).length > 0 ||
                    Object.values(formMethods.watch()).length < 1
                  }
                >
                  Next
                </Button>
              </StyledServiceButtonWrapper>
            </Col>
          </Row>
        </Space>
      </form>
    </FormProvider>
  );
}
